import React, { useState } from 'react';
import { Input, Tooltip } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import editIcon from '../../assets/img/edit-icon.svg';
import Grid from '@material-ui/core/Grid';
import { EditedDivStyle, StyledLogo, EditedDivStyleLabel, StyledButton } from './EditQueryNameStyle';
import { pushSavedQueryName } from '../../slices/QueriesManagerSlice';
import { showDialogWin, pushIsSaveAsPopUp } from '../../slices/customQueryHeaderSlice';

const EditQueryName = () => {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const savedQueryName = useSelector(state => state.queriesManager.queryName);
  const documentName = useSelector(state => state.queriesManager.documentName);
  const isBritSave = useSelector(state => state.customQueryHeader.isBritSave);

  if (!editMode) {
    return /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(EditedDivStyle, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: savedQueryName ? savedQueryName : documentName,
      arrow: true
    }, /*#__PURE__*/React.createElement(EditedDivStyleLabel, null, savedQueryName ? savedQueryName : documentName)), !isBritSave && /*#__PURE__*/React.createElement(StyledButton, {
      variant: "contained",
      onClick: () => {
        dispatch(showDialogWin(true));
        dispatch(pushIsSaveAsPopUp(false));
      }
    }, /*#__PURE__*/React.createElement(StyledLogo, {
      alt: "edit",
      src: editIcon
    }))));
  } else {
    return /*#__PURE__*/React.createElement(EditedDivStyle, null, /*#__PURE__*/React.createElement(Input, {
      value: savedQueryName,
      onChange: event => {
        var targetValue = event.target.value;
        var regex = /^[0-9a-zA-Z\s]+$/;

        if (regex.test(targetValue) || targetValue === '') {
          dispatch(pushSavedQueryName(targetValue));
        }
      }
    }), /*#__PURE__*/React.createElement(StyledButton, {
      onClick: () => {
        setEditMode(false);

        if (!savedQueryName.length) {
          dispatch(pushSavedQueryName('New Query Name'));
        }
      },
      variant: "contained"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCheck
    })));
  }
};

export default EditQueryName;